import { render, staticRenderFns } from "./SenserType.vue?vue&type=template&id=f0b64d9e&scoped=true&"
import script from "./SenserType.vue?vue&type=script&lang=js&"
export * from "./SenserType.vue?vue&type=script&lang=js&"
import style0 from "./SenserType.vue?vue&type=style&index=0&id=f0b64d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b64d9e",
  null
  
)

export default component.exports